import apiService from "./apiService";
import { BuyerModel } from "../models/BuyerModel";

const buyerService = {
  getBuyer: async (buyerId: number) => {
    const buyer = await apiService.get(`/Buyer/${buyerId}`);
    return new BuyerModel(buyer);
  }
}

export default buyerService;